// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"326":"83c0d10f","602":"90b77124"}[chunkId] + ".chunk.css";
};